// This function allow to reference all chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "" + {"885":"css/admin-app.7011","3680":"css/app.7011"}[chunkId] + ".css";
};